import {
	connect
} from 'react-redux'
import GearModelsComponent from '../components/GearModelsComponent.jsx';
import {
	closeGearModelModal
} from '../actions';

const mapStateToProps = (state) => ({
	showModal: state.getIn(['gearModelReducer', 'showModal']),
	showUploadModal: state.getIn(['gearModelReducer', 'showUploadModal']),
})

const mapDispatchToProps = (dispatch) => ({
	closeModal: () => {
		dispatch(closeGearModelModal());
	},
})

const GearModelsContainer = connect(
	mapStateToProps,
	mapDispatchToProps
)(GearModelsComponent)

export default GearModelsContainer;


// WEBPACK FOOTER //
// ./src/containers/GearModelsContainer.jsx